import React from 'react';
import { withTranslation } from 'react-i18next';
import { Box } from 'src/kit/Box';
import EmployerLayout from './EmployerLayout';
import { EmployerFeatures, EmployerSchools, EmployerClients } from './organisms';
import EmployerSignupSection from './EmployerSignupSection';
import {
  HeroSection,
  BackgroundGrid,
  GlowNode,
  HeroTitle,
  HeroSubtitle,
  CTAButton,
  StatsRow,
  Stat,
  StatNumber,
  StatLabel
} from './atoms/StyledFeatures';

const EmployerFeaturesPage = ({ t }) => {
  return (
    <EmployerLayout>
      <HeroSection>
        <BackgroundGrid />
        <GlowNode top="-200px" left="-150px" color="rgba(45, 189, 150, 0.08)" />
        <GlowNode bottom="-200px" right="-150px" color="rgba(201, 168, 76, 0.06)" />

        <HeroTitle>Built for high-performance hiring teams.</HeroTitle>

        <HeroSubtitle>
          Every feature is designed around speed, signal quality and structured evaluation — from distribution to ranked
          shortlist.
        </HeroSubtitle>

        <Box
          as="a"
          href="/auth/sign_up/company"
          style={{
            position: 'relative',
            zIndex: 2,
            display: 'inline-block',
            background: '#ffffff',
            color: '#0d1b2a',
            padding: '14px 32px',
            borderRadius: '4px',
            fontWeight: 600,
            fontSize: '0.95rem',
            textDecoration: 'none',
            border: '1.5px solid #ffffff',
            transition: 'background 0.2s, color 0.2s, transform 0.15s',
            marginTop: '40px'
          }}
          css={`
            &:hover {
              background: #2dbd96;
              color: #0d1b2a;
              border-color: #2dbd96;
              transform: translateY(-1px);
            }
          `}
        >
          Create company account
        </Box>

        <StatsRow>
          <Stat>
            <StatNumber>60+</StatNumber>
            <StatLabel>Universities</StatLabel>
          </Stat>
          <Stat>
            <StatNumber>300+</StatNumber>
            <StatLabel>Technical Questions</StatLabel>
          </Stat>
          <Stat>
            <StatNumber>10</StatNumber>
            <StatLabel>Days to Shortlist</StatLabel>
          </Stat>
        </StatsRow>
      </HeroSection>

      <EmployerFeatures />
      <EmployerSchools />
      <EmployerClients />
      <EmployerSignupSection t={t} />
    </EmployerLayout>
  );
};

export default withTranslation(['translations'])(EmployerFeaturesPage);
